import React, {Component, PropsWithChildren} from "react"

import * as styles from './styles.module.scss';
import cls from "classnames"
import {IdHeading} from "components/organisms/IdHeading";

type heading = 1|2|3|4|5|6

type Props = {
    text: string,
    className?: string,
    headingClassName?: string,
    bgClassName?: string,
    headingLevel?: heading
    headingAlign?: "center" | "left"
    containerSize?: "large" | "normal"
}

export const BlockHeading = ({ text, className, headingClassName, bgClassName, headingLevel = 2, children, headingAlign, containerSize }: PropsWithChildren<Props>) => {
    return (
        <div className={cls(styles.wrapper, className ? className : "bg-light-gray")}>
            {bgClassName && (<div className={bgClassName}></div>)}
            <div className={cls("bs-flex-container", containerSize === "normal" ? "" : "l")}>
                <div className={cls(styles.heading, headingAlign == "left" ? styles.left : "")}>
                    {headingLevel > 0
                    ? <IdHeading headingLevel={headingLevel} className={headingClassName}>
                        {text}
                    </IdHeading>
                    : <p className={cls(styles.headerNoLevel, headingClassName)}>{text}</p>}
                </div>
            </div>
            <div>
                {children}
            </div>
        </div>
    )
}
